export class Logger {
    private logLevel: number;
    private moduleName: string;

    constructor(moduleName: string, logLevel: number = 0) {
        this.moduleName = moduleName;
        this.logLevel = Math.max(0, Math.min(3, logLevel)); // Clamp between 0 and 3
    }

    /**
     * Sets the logging level.
     * @param level 0 = none, 1 = high-level, 2 = mid-level, 3 = detailed
     */
    setLogLevel(level: number): void {
        this.logLevel = Math.max(0, Math.min(3, level)); // Clamp between 0 and 3
    }

    getLogLevel(): number {
        return this.logLevel;
    }


    /**
     * Logs a message if the specified level is at or below the current log level.
     * @param level The log level for this message
     * @param message The message to log
     */
    log(level: number, message: string | (() => string)): void {
        if (this.logLevel >= level) {
            if (typeof message === 'function') {
                message = message();
            }
            const prefix = `[${this.moduleName}]`;
            let color: string;
            switch (level) {
                case 1:
                    color = 'color: black';
                    break;
                case 2:
                    color = 'color: green';
                    break;
                case 3:
                    color = 'color: orange';
                    break;
                default:
                    color = 'color: black';
            }
            console.log(`%c${prefix} ${message}`, color);
        }
    }

    /**
     * Logs an error message in red.
     * @param message The error message to log
     */
    error(message: string): void {
        console.error(`%c[${this.moduleName}] ${message}`, 'color: red');
    }
}